import { Button, Card, Row } from 'antd'
import CustomBreadCrumb from 'components/Common/CustomBreadCrumb'
import useFetch from 'elements/Hooks/useFetch'
import PageTitle from 'elements/PageTitle'
import DateCell from 'elements/Table/Cells/DateCell'
import StatusCell from 'elements/Table/Cells/StatusCell'
import CustomTable from 'elements/Table/CustomTable'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function UserManagement() {
  const { data, fetching, fetch } = useFetch({
    url: 'profiles',
  })

  const columns = [
    {
      Header: 'Code',
      accessor: '_key',
      Cell: ({ value, original }) => <Link to={{ pathname: `/users/${original._key}/update` }}>{value}</Link>,
    },
    {
      Header: 'Full Name',
      accessor: 'partner.member.fn',
    },
    {
      Header: 'Username',
      accessor: 'username',
    },
    {
      Header: 'Realm',
      accessor: 'realm',
    },
    {
      Header: 'Last Login',
      accessor: 'lastUpdate',
      Cell: DateCell,
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
  ]

  return (
    <div className="space-y-2">
      <Card>
        <Row>
          <CustomBreadCrumb items={[{ text: 'Profile Management' }]} />
          <PageTitle
            title={'Profile Management'}
            subtitle={'Manage Your Profiles.'}
            color={'#ff9935'}
            iconType={'fire'}
          />
        </Row>
      </Card>
      <Row>
        <Card>
          <CustomTable
            {...{
              CreateButton: () => (
                <Link to={{ pathname: `/users/new` }}>
                  <Button type={'primary'} size="small" icon={'plus'}>
                    New
                  </Button>
                </Link>
              ),
              data,
              fetch,
              fetching,
              columns,
            }}
          />
        </Card>
      </Row>
    </div>
  )
}

export default UserManagement
